<template>
  <div class="c-form-input">
    <label
      class="c-form-input__label"
      v-bind:class="requiredCssClass"
      v-bind:for="id">
      {{ label }}
    </label>
    <input
      class="c-form-input__control"
      v-bind="$attrs"
      v-bind:id="id"
      v-bind:type="type"
      v-bind:value="value"
      v-on:input="updateValue">
    <span
      class="c-form-input__validation-message"
      v-bind:id="errorId"
      v-bind:aria-label=validationMessage
      v-if="validationError">
      {{ validationMessage }}
    </span>
  </div>
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    id: {
      required: true,
      type: String,
    },
    label: {
      required: true,
      type: String,
    },
    required: {
      required: false,
      type: Boolean,
    },
    type: {
      default: 'text',
      required: false,
      type: String,
    },
    validationError: {
      default: false,
      required: false,
      type: Boolean,
    },
    validationMessage: {
      required: false,
      type: String,
    },
    value: {
      type: [String, Number],
    },
  },
  computed: {
    errorId() {
      return `${this.id}ErrorMsg`;
    },
    requiredCssClass() {
      return this.required ? 'c-form-input__label--required' : '';
    },
  },
  methods: {
    updateValue(event) {
      this.$emit('input', event.target.value);
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/components/reportAProblem/report-a-problem/_vue/FormInput.vue